'use client';

// NO 'use client' here. This remains a Server Component.
import Link from 'next/link';
import { FlashSalesSlider } from './FlashSalesSlider';
import { FlashSalesHeader } from './FlashSalesHeader'; // <-- Import the new client component
import { activeFlashSale } from '@/utils/activeFlashSlae';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { FlashSalesSkeleton } from './FlashSalesSkeleton';
import { API_HOME_THINGS } from '@/constant/apiRout';

const FlashSales = () => {
  const { data: homeThings, isLoading } = useFetcherCSR(API_HOME_THINGS);
  const products = homeThings?.featured_products ?? [];

  if (isLoading) return <FlashSalesSkeleton />;

  if (
    products.length === 0 ||
    !homeThings?.homepage_settings?.features?.hot_deals
  ) {
    return null;
  }

  const activeFlash = activeFlashSale(
    products?.[0]?.hot_deals_start_datetime,
    products?.[0]?.hot_deals_end_datetime
  );

  return (
    <section className="padding-top padding-bottom section-bg">
      <div className="container">
        {activeFlash && (
          <FlashSalesHeader endDate={products?.[0]?.hot_deals_end_datetime} />
        )}
        <div className="product__wrapper">
          <FlashSalesSlider products={products} />
        </div>

        <div className="d-sm-none text-center mt-4">
          <Link className="trk-btn trk-btn--primary" href="/hot-deals">
            View All
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FlashSales;
